export const TRIPADVISOR_RESULTS_SAVE = "TRIPADVISOR_RESULTS_SAVE";
